import React, { useState } from 'react';
import { FieldArrayRenderProps, FormikProps } from 'formik';
import { Button, Table } from 'antd';
import cx from 'classnames';
import { ColumnsType } from 'antd/es/table/interface';

import { ClientBulkImportForm } from '../ClientBulkImportTableSection';
import { pageDefaultSizeTable } from 'constants/index';
import {
  getAgreementTypeLabel,
  isFileUploaderRequired,
} from 'utils/clientUtils';
import FormItem from 'components/formik/FormItem';
import AgreementUploader from 'components/modals/ClientModal/ServiceAgreement/AgreementUploader';
import { CustomerBulkImportDetailsModel } from '../interface';

import styles from '../ClientBulkImportTable.module.less';

type Props = FieldArrayRenderProps & {
  isAdmin: boolean;
  handleEditClientModalOpen: (
    clientDetails: CustomerBulkImportDetailsModel,
  ) => void;
};

export default function ClientBulkImportTableForm(props: Props) {
  const { form, isAdmin, handleEditClientModalOpen } = props;
  const [currentPage, setCurrentPage] = useState(1);

  const { customers } = (form as FormikProps<ClientBulkImportForm>).values;

  const handlePaginationChange = (page: number) => {
    setCurrentPage(page);
  };

  const columns: ColumnsType<CustomerBulkImportDetailsModel> = [
    {
      title: 'Company name',
      key: 'companyName',
      render: (customer: CustomerBulkImportDetailsModel) =>
        customer.generalInfo.companyInfo.companyName,
    },
    {
      title: 'Company email',
      key: 'companyEmail',
      render: (customer: CustomerBulkImportDetailsModel) =>
        customer.generalInfo.companyInfo.companyEmail,
    },
    {
      title: 'Company address',
      key: 'companyAddress',
      render: (customer: CustomerBulkImportDetailsModel) =>
        customer.generalInfo.companyInfo.location.address,
    },
    {
      title: 'Agreement type',
      key: 'agreementType',
      render: (customer: CustomerBulkImportDetailsModel) =>
        getAgreementTypeLabel(
          customer.agreementDetailsInfo.agreementDetailsType,
        ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (
        customer: CustomerBulkImportDetailsModel,
        record: CustomerBulkImportDetailsModel,
        index: number,
      ) => {
        const correctIndex =
          currentPage === 1
            ? index
            : (currentPage - 1) * pageDefaultSizeTable + index;

        const fieldName = `customers[${correctIndex}].agreementDetailsInfo.agreementAttachments`;

        return (
          <div className={styles.btnBox}>
            {isFileUploaderRequired(
              record.agreementDetailsInfo.agreementDetailsType,
            ) && (
              <FormItem name={fieldName} showValidateError={false}>
                <div className={styles.upload}>
                  <AgreementUploader
                    fieldName={fieldName}
                    isSimpleUpload={true}
                    isAdmin={isAdmin}
                    files={customer.agreementDetailsInfo.agreementAttachments}
                  />
                </div>
              </FormItem>
            )}
            <div>
              <Button onClick={() => handleEditClientModalOpen(customer)}>
                Edit
              </Button>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <>
      {customers.length > 0 && (
        <Table
          className={cx(styles.table, 'custom-table')}
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={customers}
          pagination={{
            total: customers.length || 0,
            pageSize: pageDefaultSizeTable,
            onChange: handlePaginationChange,
            showSizeChanger: false,
          }}
          scroll={{ x: '100%' }}
        />
      )}
    </>
  );
}
